import type { HasEntityTypeId } from "../../../core/entity/EntityTypeId.enum"
import { EntityTypeId } from "../../../core/entity/EntityTypeId.enum"

const terrainMesh1EntityTypeIdList = [
  EntityTypeId.Plain,
  EntityTypeId.Snow,
  EntityTypeId.Desert,
  EntityTypeId.Sea,
  EntityTypeId.Mountain,
  EntityTypeId.River,
  EntityTypeId.Shoal,
  EntityTypeId.Forest,
  EntityTypeId.Swamp,
  EntityTypeId.Marsh,
  EntityTypeId.Jungle,
  EntityTypeId.Deadwood,
  EntityTypeId.Lake,
]

export default function isEntityTerrainMesh1(ent: HasEntityTypeId) {
  return terrainMesh1EntityTypeIdList.includes(ent.etype_id)
}